﻿var locationSearchForm = function () {
    $(function () {
        var tempSiteLocatorSelectedPlaceId = null;

        var $locationSearchKeywords = $("#locationSearchKeywords");
        var $siteLocatorSelectedPlaceId = $("#site-locator-selected-place-id");
        var $siteLocatorSearchButton = $("#site-locator-search-button");

        $locationSearchKeywords.autocomplete({
            source: function (request, response) {

                $locationSearchKeywords.addClass("loadinggif");

                $.ajax({
                    url: "/umbraco/surface/calculatequote/getcountryplaces",
                    type: "GET",
                    dataType: "json",
                    data: {
                        placeId: 31638,//AU
                        filter: request.term,
                        excludePoBoxes: true
                    },
                    success: function (data) {
                        var results = JSON.parse(data);
                        // Populate the array that will be passed to the response callback.
                        var autocompleteObjects = [];
                        for (var i = 0; i < results.length; i++) {
                            var object =
                            {
                                // Used by jQuery Autocomplete to show
                                // autocomplete suggestions as well as
                                // the text in yourInputTextBox upon selection.
                                // Assign them to a value that you want the user to see.
                                value: results[i].name,
                                label: results[i].name,

                                // Put our own custom id here.
                                // If you want to, you can even put the result object.
                                id: results[i].placeId
                            };

                            autocompleteObjects.push(object);
                        }

                        $locationSearchKeywords.removeClass("loadinggif");

                        response(autocompleteObjects);
                    }
                });
            },
            minLength: 2,
            select: function (event, ui) {
                $siteLocatorSelectedPlaceId.val(ui.item.id);
                tempSiteLocatorSelectedPlaceId = ui.item.id;
                setTimeout(function () {
                    $siteLocatorSearchButton.click();
                }, 5);
            },
            open: function (event, ui) {
                $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
            }
        });

        $locationSearchKeywords.blur(function () {
            if (!tempSiteLocatorSelectedPlaceId) {
                $siteLocatorSelectedPlaceId.val("");
                $locationSearchKeywords.val("");
            }
            tempSiteLocatorSelectedPlaceId = null;
        });

        if ($("#location-search-form").length > 0) {
            $("#location-search-form").validate({
                submitHandler: function () {
                    if (!$siteLocatorSelectedPlaceId.val()) {
                        return;
                    }
                    var path = window.location.protocol + "//" + window.location.hostname;
                    if (window.location.port.length !== 0)
                        path = path + ":" + window.location.port;
                    path = path + "/couriers-" + $("#locationSearchKeywords").val().replace(/[^a-z0-9 ]/ig, '').trim().replace(new RegExp(" ", "g"), "-") + "/";
                    path = path + "?p=" + $siteLocatorSelectedPlaceId.val();
                    window.location = path.toLowerCase();
                }
            });
        }
    });
}

module.exports = locationSearchForm;